import {Hydra} from '../generic/hydra';

import {CommissionSeanceParticipationInterface} from './CommissionSeanceParticipation';
import {LienInteretInterface} from './LienInteret';
import {Mandat as MandatBaseInterface} from '../../interface/api/Mandat';

export type MandatInterface = MandatBaseInterface;

export class Mandat extends Hydra implements MandatInterface {

    id?: number | null;

    utilisateur?: any | null;

    mandatType?: any | null;

    commission?: any | null;

    /* Date de début de mandat.
     */
    dateDebut?: string | Date | null;

    /* Date de fin de mandat
     */
    dateFin?: string | Date | null;

    commissionSeanceParticipations?: CommissionSeanceParticipationInterface[] | string[] | null = [];

    liensInterets?: LienInteretInterface[] | string[] | null = [];

    /* read only
     */
    mandatActif?: boolean | null = false;


    constructor(options: MandatInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
